import { useState } from "react";

// components
import Button from "../../../components/Button/Button";
import Typography from "../../../components/Typography/Typography";
import InputComponentManagement from "./InputComponentManagement/InputComponentManagement";
import SmsComponentManagement from "./SmsComponentManagement/SmsComponentManagement";

// styled components
import { MainContent, WrapperTitle } from "./managementStyle";
import { Container } from "../../../theme/GlobalStyle";
import WrapperButton from "./WrapperBtn/WrapperButton";
import { useChangeStatusSms, useDetailSms } from "../../../hooks/useAccounting";
import { useParams } from "react-router-dom";
import { InputField1 } from "../../../components/InputField1/InputField1";

const ManagementSmsDetail = () => {
  const [activePage, setActivePage] = useState("مدیریت ارسال پیام");
  const { id } = useParams();

  const { data: detailSms } = useDetailSms(id);

  const sms_pannel = detailSms?.data?.data?.sms_panel;
  const options = detailSms?.data?.data?.options;
  const auth = detailSms?.data?.data?.auth;

  // handle active sms panel
  const { mutateAsync: changeStatus, isLoading: loadingSms } =
    useChangeStatusSms();

  const handleActivation = async () => {
    await changeStatus(id);
  };

  return (
    <Container>
      <MainContent>
        <WrapperTitle>
          <div className="w-100 d-flex align-items-center justify-content-between">
            <Typography weight="bold">{sms_pannel?.name}</Typography>
            {sms_pannel && (
              <Button
                size="14px"
                bgColor={
                  sms_pannel?.status.color === "success" ? "#198754" : "#F1416C"
                }
                color="#fff"
                small="100px"
                onclick={handleActivation}
              >
                {sms_pannel?.status.title}
              </Button>
            )}
          </div>
          <div className="flex flex-wrap w-100 row">
            {auth?.map((item, index) => {
              const key = Object.keys(item);
              return (
                <div className="col-4" key={index}>
                  <InputField1
                    type="text"
                    defaultValue={item[key[index]]}
                    label={key[index]}
                  />
                </div>
              );
            })}
            <div className="row">
              <div className="col-4">
                <Button
                  bgColor="#009EF7"
                  color="#fff"
                  small="100px"
                  size="14px"
                >
                  ویرایش
                </Button>
              </div>
            </div>
          </div>
        </WrapperTitle>

        <WrapperButton activePage={activePage} setActivePage={setActivePage} />
        {activePage === "مدیریت ارسال پیام" ? (
          <SmsComponentManagement />
        ) : (
          <InputComponentManagement options={options} />
        )}
      </MainContent>
    </Container>
  );
};

export default ManagementSmsDetail;
